module.exports = __webpack_public_path__ + "static/media/sc.90c9327b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/sc.svg
// module id = 240
// module chunks = 0